import { ExpenseBankingTransactionForExpenseDetailFragment } from 'generated/resources/graphql'

import { useNavigation } from 'modules/core/hooks/useNavigation'
import { dateBackendDateTimeToUI } from 'modules/core/lib/dates'
import MoneyWithCurrency from 'modules/core/lib/money'

import { transactionURL } from 'modules/expenses/lib/transactions/transactionUrl'

export const useCollapsableTransactions = (
  transactions: ExpenseBankingTransactionForExpenseDetailFragment[],
  locale: string
) => {
  const { navigation } = useNavigation()

  return transactions.map((transaction) => {
    return {
      id: transaction.id,
      amount: MoneyWithCurrency({
        amount: transaction.amountCents,
        currency: transaction.currency,
        locale,
      }),
      date: dateBackendDateTimeToUI(transaction.bookingDate),
      to: transactionURL(transaction, navigation),
    }
  })
}
